import { Injectable } from '@angular/core';
import {
    ResourceCRUD,
    ResourceParams
} from 'ng2-resource-rest';

interface IProductInput {
}

export interface IProduct  {
    id          : number;
    name        : string;
    price       : number;
    type        : string;
    balls       : number;
    pumps       : number;
    hours?      : number;
    colspan?    : number;
    perPerson?  : number;
    perPersonPerHour? : number;
    label?      : string;
    info?       : string;
    perPersonLabel? : string;
}

@Injectable()
@ResourceParams({
    url: '/api/product'
})
export class Product extends ResourceCRUD<IProductInput, IProduct, IProduct> {}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/product.ts